// extracted by mini-css-extract-plugin
module.exports = {"feature-container":"Feature_feature-container__2UEW5","feature-icon":"Feature_feature-icon__13Cjw"};